'use client';

import { useId } from 'react';
import { Gradient } from '../gradient';

export const Pleasure = () => {
  const gradientId = useId();

  return (
    <>
      <Gradient gradientId={gradientId} />
      <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_3451_22579)">
          <path
            d="M323.572 218.723C333.913 150.476 286.97 86.7681 218.723 76.4276C150.476 66.0871 86.7681 113.03 76.4276 181.277C66.0871 249.524 113.03 313.232 181.277 323.572C249.524 333.913 313.232 286.97 323.572 218.723Z"
            fill={`url(#${gradientId})`}
          />
          <path
            d="M114.413 281.25C89.4603 256.249 84.4141 219.375 84.4141 219.375C84.4141 219.375 89.4615 253.173 116.289 280C143.117 306.828 168.785 314.375 168.785 314.375C168.785 314.375 139.367 306.251 114.413 281.25Z"
            fill="white"
          />
          <path
            d="M130.535 169.25C130.577 166.547 131.158 163.879 132.243 161.403C133.329 158.927 134.897 156.692 136.856 154.828C138.886 152.814 141.347 151.287 144.054 150.364C146.831 149.435 149.789 149.186 152.682 149.636C155.562 150.124 158.286 151.284 160.633 153.022C162.907 154.757 164.766 156.976 166.076 159.519C167.344 161.906 168.123 164.521 168.369 167.213C168.614 169.904 168.321 172.618 167.506 175.195C167.216 170.284 165.585 165.548 162.79 161.5C161.533 159.66 159.92 158.09 158.046 156.884C156.172 155.678 154.075 154.859 151.88 154.477C149.677 154.144 147.43 154.26 145.275 154.821C143.119 155.381 141.1 156.374 139.339 157.738C135.399 160.691 132.353 164.675 130.535 169.25Z"
            fill="#2D5B5B"
          />
          <path
            d="M255.945 189.466C255.984 186.764 256.561 184.097 257.642 181.621C258.723 179.145 260.286 176.909 262.241 175.044C264.275 173.034 266.735 171.509 269.439 170.579C272.214 169.634 275.177 169.382 278.072 169.845C280.966 170.308 283.703 171.473 286.043 173.238C288.317 174.972 290.177 177.191 291.486 179.734C292.759 182.119 293.542 184.735 293.787 187.427C294.033 190.12 293.736 192.834 292.916 195.41C292.621 190.501 290.991 185.765 288.2 181.715C286.969 179.853 285.365 178.266 283.489 177.056C281.612 175.846 279.505 175.038 277.301 174.684C275.096 174.331 272.842 174.439 270.682 175.001C268.521 175.564 266.501 176.569 264.749 177.953C260.801 180.898 257.752 184.884 255.945 189.466Z"
            fill="#2D5B5B"
          />
          <path
            d="M235.768 210.007C235.372 213.78 234.213 217.434 232.361 220.745C230.509 224.056 228.002 226.955 224.994 229.266C221.985 231.578 218.538 233.253 214.862 234.19C211.186 235.127 207.357 235.307 203.61 234.717C199.862 234.128 196.273 232.782 193.062 230.762C189.851 228.741 187.084 226.089 184.931 222.966C182.777 219.842 181.282 216.313 180.535 212.594C179.789 208.874 179.807 205.042 180.588 201.329L235.768 210.007Z"
            fill="#2D5B5B"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3451_22579"
            x="69"
            y="71"
            width="262"
            height="262"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22579"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22579"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
